if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.prevButton = this.querySelector('.product-media-modal__nav--prev');
      this.nextButton = this.querySelector('.product-media-modal__nav--next');
      this.counterCurrent = this.querySelector('.modal-counter--current');

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.navigate(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.navigate(1));
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const targetId = this.openedBy.getAttribute('data-media-id');
      this.querySelectorAll('[data-media-id]').forEach(el => el.classList.remove('is-active'));
      const activeMedia = this.querySelector(`[data-media-id="${targetId}"]`);
      if (activeMedia) {
        activeMedia.classList.add('is-active');
        const tmpl = activeMedia.querySelector('template');
        if (tmpl && activeMedia.nodeName === 'DEFERRED-MEDIA' &&
            tmpl.content.querySelector('.js-youtube')) {
          activeMedia.loadContent();
        }
      }
      this.updateCounter();
    }

    navigate(direction) {
      const items = Array.from(this.querySelectorAll('[data-media-id]'));
      const activeIdx = items.findIndex(el => el.classList.contains('is-active'));
      if (activeIdx === -1) return;
      const newIdx = (activeIdx + direction + items.length) % items.length;
      items[activeIdx].classList.remove('is-active');
      items[newIdx].classList.add('is-active');
      this.updateCounter();
    }

    updateCounter() {
      if (!this.counterCurrent) return;
      const items = Array.from(this.querySelectorAll('[data-media-id]'));
      const activeIdx = items.findIndex(el => el.classList.contains('is-active'));
      this.counterCurrent.textContent = activeIdx + 1;
    }
  });
}
